import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1709.28872,959.672847 L1709.28872,1814.27733 L341.807607,1814.27733 L341.807607,1016.53253 L455.754871,1016.53253 L455.754871,1700.33006 L1595.34146,1700.33006 L1595.34146,959.672847 L1709.28872,959.672847 Z M1840.35086,434.569671 L1920,516.155912 L1122.36915,1295.78309 L757.851857,939.242102 L837.500994,857.883756 L1122.36915,1136.37087 L1840.35086,434.569671 Z M455.789055,105 L455.789055,446.955739 L797.744794,446.955739 L797.744794,560.903002 L455.789055,560.903002 L455.789055,902.630846 L341.841791,902.630846 L341.841791,560.903002 L-5.68434189e-14,560.903002 L-5.68434189e-14,446.955739 L341.841791,446.955739 L341.841791,105 L455.789055,105 Z M1538.32225,446.875976 L1538.32225,560.823239 L911.612294,560.823239 L911.612294,446.875976 L1538.32225,446.875976 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCheckPlusLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCheckPlusLine, _Component);

  var _super = _createSuper(IconCheckPlusLine);

  function IconCheckPlusLine() {
    _classCallCheck(this, IconCheckPlusLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCheckPlusLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCheckPlus",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCheckPlusLine.displayName = "IconCheckPlusLine";
  return IconCheckPlusLine;
}(Component);

IconCheckPlusLine.glyphName = 'check-plus';
IconCheckPlusLine.variant = 'Line';
IconCheckPlusLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCheckPlusLine;
export { IconCheckPlusLine };